import get from 'lodash/get';
import join from 'lodash/join';
import difference from 'lodash/difference';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import isTradablePosition from './isTradablePosition';
import BankInfo from '../SignUp/BankInfo';

import {
  fetchAccountData,
  fetchUser,
  fetchQuotesSnapQuote,
  fetchQuotesPrivate,
  fetchAccountCashTransactions,
  fetchAccountOrders,
} from '../../actions';

import {
  fetchAccountBankLinks,
} from '../../actions/bankLinks';

import {
  fetchOfferingOrders,
} from '../../actions/investment';

import {
  fetchOfferingSubscriptions,
} from '../../actions/offeringSubscriptions';

import RoutedHeader from '../Header';
import Currency from '../Currency';

import './index.css';
import SecuritiesGrid, {
  TYPE,
  DataRowPriv,
  DataRowSec,
} from './SecuritiesGrid';

import {
  prepJSONforPrivGrid,
  prepJSONforSecuritiesGrid,
} from './prepJsonForGrids';

import Button from '../Button';
import TooltipButton from '../Button/TooltipButton';
import loadGif from '../../assets/images/loading.gif';

import { LAYOUT, MIN_WIDTH } from '../Layout/enums';
import { filterActiveBankLinks } from '../../helpers/filterActiveBankLink';

export const secColumns = [
  {
    Name: 'Securities',
    Type: TYPE.LINK,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
  {
    Name: 'Quantity',
    Type: TYPE.NUMBER,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
  {
    Name: 'Purchase Price',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.DESK,
  },
  {
    Name: 'Value',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.TAB,
  },
  {
    Name: 'Total Cost',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.DESK,
  },
  {
    Name: 'Total Value',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
  {
    Name: 'Change',
    Type: TYPE.PERCENTAGE,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
];

export const privColumns = [
  {
    Name: 'Non-Traded Holdings',
    Type: TYPE.LINK,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
  {
    Name: 'Quantity',
    Type: TYPE.NUMBER,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
  {
    Name: 'Purchase Price',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.TAB,
  },
  {
    Name: 'Value',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.TAB,
  },
  {
    Name: 'Total Value',
    Type: TYPE.CURRENCY,
    Sort: null,
    SmallestLayout: LAYOUT.MOB,
  },
];


const AccountValue = ({
  amount,
  pendingOfferInvestmentCounter,
  pendingSecInvestmentCounter,
  layout,
}) => {
  let currencyStyle = 'valueAmountDesktop';
  let accountValStyle = 'labelLarge';
  let accountValGrpStyle = 'accountValGroup';

  switch (layout) {
    case LAYOUT.TAB:
      currencyStyle = 'valueAmountTablet';
      accountValStyle = 'labelMedium';
      break;
    case LAYOUT.MOB:
      currencyStyle = 'valueAmountMobile';
      accountValStyle = 'labelSmall';
      accountValGrpStyle = 'mobileAccountValGroup';
      break;
    default:
      break;
  }
  let tooltipText = '';
  const totalInvestmentsCounter = pendingOfferInvestmentCounter + pendingSecInvestmentCounter;
  if (totalInvestmentsCounter) {
    if (pendingOfferInvestmentCounter) tooltipText += `${pendingOfferInvestmentCounter} pending offer order${pendingOfferInvestmentCounter > 1 ? 's' : ''}`;
    if (pendingSecInvestmentCounter) tooltipText += `${pendingOfferInvestmentCounter ? ', ' : ''}${pendingSecInvestmentCounter} pending security order${pendingSecInvestmentCounter > 1 ? 's' : ''}`;
  }
  const pendingOrderText = `pending order${totalInvestmentsCounter > 1 ? 's' : ''}`;
  return (
    <div styleName={accountValGrpStyle}>
      <div styleName={accountValStyle}>Account Value</div>
      <Currency styleName={currencyStyle} amount={amount} />
      {
        totalInvestmentsCounter && pendingOfferInvestmentCounter && pendingSecInvestmentCounter ?
          <TooltipButton to="/history" tooltipText={tooltipText}>
            {totalInvestmentsCounter} {pendingOrderText}
          </TooltipButton> : null
      }
      {
        totalInvestmentsCounter && !(pendingOfferInvestmentCounter && pendingSecInvestmentCounter) ?
          <Button to="/history" tooltipText={tooltipText}>
            {totalInvestmentsCounter} {pendingOrderText}
          </Button> : null
      }
    </div>
  );
};

const CashAvailable = ({ amount, accountNumber }) => (
  <div styleName="cashAvailableGroup">
    <div styleName="labelMedium">Cash available</div>
    <Currency styleName="cashAmount" amount={amount} />
    <Link styleName="manageCash" to={`/account/${accountNumber}`}>Manage Account</Link>
  </div>
);

const EmptyAccountPrompt = ({
  layout, accountNumber, accountBankLinks, hasCashTransactions,
}) => {
  let fontSize = '18px';

  switch (layout) {
    case LAYOUT.TAB:
      fontSize = '18px';
      break;
    case LAYOUT.MOB:
      fontSize = '16px';
      break;
    default:
      break;
  }

  const { bankLinks, hasDeletedBankLinks } = filterActiveBankLinks(accountBankLinks);

  const addFundsGroup = (
    <div styleName="addFundsGroup">
      <div styleName="addFundsLabel" style={{ fontSize }}>
        {hasCashTransactions
          ? ('Check out our exciting IPOs and other Offerings to start building your portfolio!')
          : ('Add funds to start building your portfolio')
        }
      </div>
      {hasCashTransactions
        ? (
          <Button to="/offers" style={{ fontSize, width: '280px' }}>
            View Offers
          </Button>
        ) : (
          <Button to={`/transfers/${accountNumber}`} style={{ fontSize, width: '280px' }}>
            Add Funds
          </Button>
        )
      }
    </div>
  );

  const bankLinkButton = (<BankInfo accountNumber={accountNumber} isSignUp={false} onNext={() => {}} />);
  const bankLinkMessage = (
    <div styleName="noLinksComment">
      <span>
        For security purposes we are temporarily restricting bank link management. Please&nbsp;
      </span>
      <a href="mailto:clientservices@myipo.com" styleName="contactLink">
        contact a MyIPO representative
      </a>
      <span>
        &nbsp;to add a new bank link to your account.
      </span>
    </div>
  );
  if (bankLinks.length === 0) {
    return (!hasDeletedBankLinks ? bankLinkButton : bankLinkMessage);
  }
  return addFundsGroup;
};

const SecuritiesPrompt = () => (
  <div styleName="promptGroup">
    <div styleName="promptHeader">Securities</div>
    <Link styleName="prompt" to="/offers">
      <p>You currently hold no securities. Check out our exciting IPOs and other Offerings to start building your portfolio.
      </p>
    </Link>
  </div>
);

const getComponent = layout => ({
  cashBalance,
  accountValue,
  positions,
  priceData,
  accountNumber,
  cashTransactions,
  offeringOrdersByAccount,
  accountOrders,
  cashBalanceForAccountValue,
  offeringSubscriptionsByAccount,
  allRequestsDidFetch,
  accountBankLinks,
}) => {
  const nonPrivPos = positions.filter(isTradablePosition);
  const privPos = positions.filter(pos => !nonPrivPos.includes(pos));

  let pendingOrdersIdsSet = null;
  if (offeringSubscriptionsByAccount && offeringSubscriptionsByAccount.length) {
    const completedSubscriptionIdsSet = new Set(offeringSubscriptionsByAccount.filter(o => (o.status === 'F' || o.status === 'R' || o.status === 'C')).map(or => or.privatePlacementOrderOid));
    const orderIdsSet = new Set(offeringOrdersByAccount.map(o => o.folioPrivatePlacementOrderOid));
    pendingOrdersIdsSet = new Set([...orderIdsSet].filter(o => !completedSubscriptionIdsSet.has(o)));
  }

  const pendingInvestments = offeringOrdersByAccount.filter(inv => inv.status === 'created' || (inv.status === 'submitted' && pendingOrdersIdsSet && pendingOrdersIdsSet.has(inv.folioPrivatePlacementOrderOid)));

  const pendingSecurityInvestments = accountOrders.filter(inv =>
    inv.securityOrders.length && (inv.securityOrders[0].state === 'I' || inv.securityOrders[0].state === 'S'));

  const numPendingOfferInvestments = pendingInvestments.length;
  const numPendingSecInvestments = pendingSecurityInvestments.length;

  if (allRequestsDidFetch) {
    return (
      <div styleName="valueRowContainer">
        <div styleName="desktopValueRow">
          <div styleName="desktopCashAvailableContainer">
            <CashAvailable amount={cashBalance} accountNumber={accountNumber} />
          </div>
          <AccountValue
            amount={accountValue + cashBalanceForAccountValue}
            pendingOfferInvestmentCounter={numPendingOfferInvestments}
            pendingSecInvestmentCounter={numPendingSecInvestments}
            layout={layout}
          />
        </div>
        {((!accountValue || accountValue === 0)
          && (!cashBalance || cashBalance === 0)
          && (!positions || positions.length === 0) ?
            <EmptyAccountPrompt
              hasCashTransactions={cashTransactions && cashTransactions.length > 0}
              layout={layout}
              accountNumber={accountNumber}
              accountBankLinks={accountBankLinks}
            />
        : (
          <div styleName="chartsAndCash">
            <div styleName="mobileValueRow">
              <CashAvailable amount={cashBalance} accountNumber={accountNumber} />
            </div>
            {(positions && positions.length === 0) ?
              <SecuritiesPrompt /> : null}
            {nonPrivPos && nonPrivPos.length > 0 ?
              <SecuritiesGrid
                data={prepJSONforSecuritiesGrid(nonPrivPos, priceData)}
                columns={secColumns}
                RowRender={DataRowSec}
              /> : null }
            {privPos && privPos.length > 0 ?
              (
                <React.Fragment>
                  <SecuritiesGrid
                    data={prepJSONforPrivGrid(privPos, priceData)}
                    columns={privColumns}
                    RowRender={DataRowPriv}
                  />
                  <Link styleName="disclaimer" to="/non-traded-info">
                    <div>
                      Please note values for non-traded holdings may display
                      a lower value than the price you paid.&nbsp;
                      <mark
                        styleName="promptBlue"
                      >
                          Click here for more information regarding the value.
                      </mark>
                    </div>
                  </Link>
                </React.Fragment>
              ) : null}
          </div>))}
      </div>);
  }
  return (
    <div styleName="loading">
      <img
        src={loadGif}
        alt="Loading"
      />
    </div>
  );
};

export const Desktop = getComponent(LAYOUT.DESK);

export const Tablet = getComponent(LAYOUT.TAB);

export const Mobile = getComponent(LAYOUT.MOB);

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allRequestsDidFetch: false,
    };
  }

  async componentDidMount() {
    await this.props.fetchAccountBankLinks(this.props.accountNumber);
    await this.props.fetchOfferingSubscriptions(this.props.accountNumber, true);
    await this.props.fetchOfferingOrders(this.props.accountNumber);
    await this.props.fetchAccountData(this.props.accountNumber);
    await this.props.fetchAccountOrders(this.props.accountNumber);
    await this.props.fetchAccountCashTransactions(this.props.accountNumber);
    await this.props.fetchUser();
  }

  componentWillReceiveProps(nextProps) {
    const diff = difference(nextProps.positions, this.props.positions);

    if (diff.length) {
      this.getQuotes(nextProps.positions);
    }

    if (
      nextProps.userIsFetching !== this.props.userIsFetching ||
      nextProps.priceDataIsFetching !== this.props.priceDataIsFetching ||
      nextProps.cashBalanceIsFetching !== this.props.cashBalanceIsFetching ||
      nextProps.accountValueIsFetching !== this.props.accountValueIsFetching ||
      nextProps.positionsIsFetching !== this.props.positionsIsFetching ||
      nextProps.cashTransactionsIsFetching !== this.props.cashTransactionsIsFetching ||
      nextProps.offeringOrdersByAccountIsFetching !== this.props.offeringOrdersByAccountIsFetching ||
      nextProps.offeringSubscriptionsByAccountIsFetching !== this.props.offeringSubscriptionsByAccountIsFetching ||
      nextProps.accountOrdersIsFetching !== this.props.accountOrdersIsFetching
    ) {
      this.setState({
        allRequestsDidFetch: !(
          nextProps.userIsFetching ||
          nextProps.priceDataIsFetching ||
          nextProps.cashBalanceIsFetching ||
          nextProps.accountValueIsFetching ||
          nextProps.positionsIsFetching ||
          nextProps.cashTransactionsIsFetching ||
          nextProps.offeringOrdersByAccountIsFetching ||
          nextProps.offeringSubscriptionsByAccountIsFetching ||
          nextProps.accountOrdersIsFetching
        ),
      });
    }
  }

  getQuotes(positions) {
    const symbols = positions
      .filter(isTradablePosition)
      .map(pos => pos.security.ticker);

    if (symbols.length > 0) {
      this.props.fetchQuotesSnapQuote(join(symbols, ','));
    }

    const privateSymbols = positions
      .filter(pos => !symbols.includes(pos.security.ticker))
      .map(pos => pos.security.ticker);
    if (privateSymbols.length > 0) {
      this.props.fetchQuotesPrivate(join(privateSymbols, ','));
    }
  }

  render() {
    const propsToPassToChild = {
      cashBalance: this.props.cashBalance,
      cashBalanceForAccountValue: this.props.cashBalanceForAccountValue,
      accountValue: this.props.accountValue,
      priceData: this.props.priceData,
      positions: this.props.positions,
      accountNumber: this.props.accountNumber,
      cashTransactions: this.props.cashTransactions,
      offeringOrdersByAccount: this.props.offeringOrdersByAccount,
      offeringSubscriptionsByAccount: this.props.offeringSubscriptionsByAccount,
      allRequestsDidFetch: this.state.allRequestsDidFetch,
      accountOrders: this.props.accountOrders,
      accountBankLinks: this.props.accountBankLinks,
    };
    return (
      <div>
        <RoutedHeader />
        <MediaQuery
          minWidth={MIN_WIDTH.DESK}
        >
          <Desktop
            {...propsToPassToChild}
          />
        </MediaQuery>
        <MediaQuery
          minWidth={MIN_WIDTH.TAB}
          maxWidth={MIN_WIDTH.DESK - 1}
        >
          <Tablet
            {...propsToPassToChild}
          />
        </MediaQuery>
        <MediaQuery
          maxWidth={MIN_WIDTH.TAB - 1}
        >
          <Mobile
            {...propsToPassToChild}
          />
        </MediaQuery>
      </div>
    );
  }
}

Portfolio.propTypes = {
  fetchAccountData: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  authToken: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  accountValue: PropTypes.number,
  // eslint-disable-next-line react/no-typos
  cashBalance: PropTypes.number.isRequired,
  cashTransactions: PropTypes.arrayOf(PropTypes.shape({})),
  positions: PropTypes.arrayOf(PropTypes.shape({})),
  offeringSubscriptionsByAccount: PropTypes.arrayOf(PropTypes.shape({})),
};

Portfolio.defaultProps = {
  firstName: 'Guest',
  positions: [],
  priceData: {},
  accountValue: null,
  cashTransactions: [],
  offeringSubscriptionsByAccount: [],
};

const mapStateToProps = state => ({
  firstName: get(state, 'user.data.identity.firstName', 'Guest'),
  userIsFetching: get(state, 'user.isFetching'),
  authToken: state.authToken,
  accountNumber: state.currentAccount,
  priceData: get(state, 'quoteData', {}),
  priceDataIsFetching: get(state, 'quoteData.isFetching', {}),
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades')),
  cashBalanceIsFetching: get(state.accountCashBalanceByAccount[state.currentAccount], 'isFetching'),
  cashBalanceForAccountValue: state.accountCashBalanceByAccount && state.currentAccount ?
    Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceBeforeCurrentActivity')) : 0,
  accountValue: get(state, 'accountValue.accountValue'),
  accountValueIsFetching: get(state, 'accountValue.accountValueIsFetching'),
  positions: get(state, `accountPositionsByAccount[${get(state, 'currentAccount', '')}].data`, []),
  positionsIsFetching: get(state, `accountPositionsByAccount[${get(state, 'currentAccount', '')}].isFetching`),
  cashTransactions: get(state, `accountCashTransactionsByAccount.${state.currentAccount}.data`),
  cashTransactionsIsFetching: get(state, `accountCashTransactionsByAccount.${state.currentAccount}.isFetching`),
  offeringOrdersByAccount: get(state, `offeringOrdersByAccount[${get(state, 'currentAccount')}].data`, []),
  offeringOrdersByAccountIsFetching: get(state, `offeringOrdersByAccount.${state.currentAccount}.isFetching`),
  offeringSubscriptionsByAccount: get(state, `offeringSubscriptionsByAccount[${get(state, 'currentAccount')}].data`, []),
  offeringSubscriptionsByAccountIsFetching: get(state, `offeringSubscriptionsByAccount[${get(state, 'currentAccount')}].isFetching`),
  accountOrders: get(state, `accountOrdersByAccount[${get(state, 'currentAccount')}].data`, []),
  accountOrdersIsFetching: get(state, `accountOrdersByAccount[${get(state, 'currentAccount')}].isFetching`),
  accountBankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
});

const mapDispatchToProps = {
  fetchAccountData,
  fetchOfferingOrders,
  fetchAccountOrders,
  fetchUser,
  fetchQuotesSnapQuote,
  fetchQuotesPrivate,
  fetchAccountCashTransactions,
  fetchOfferingSubscriptions,
  fetchAccountBankLinks,
};


export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);



// WEBPACK FOOTER //
// ./src/components/Portfolio/index.js